/** @format */

import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import SelectFromRest from '../../components/Form/SelectFromRest';
import I18n from '../../core/i18n';
import adescomStyle from 'assets/jss/adescom/adescomStyle';
import { componentDebug } from '../../core/debug';
import oplAppStyle from '../../assets/themes/OPL/jss/App/OplAppStyle';

class SimpleSelectRest extends Component {
    handleSelectFunc = (e, stateName, require) => {
        if (!this.props.callback) {
            componentDebug('no callback');
            return;
        }
        this.props.callback(e, stateName, require);
    };

    render() {
        const { restElements, stateName, idState, idSelected, propKey, propValue, emptyLabel, label, required } = this.props;
        return (
            <SelectFromRest
                callback={this.handleSelectFunc}
                required={required}
                restElements={restElements}
                stateName={stateName}
                stateObjectState={idState}
                selectedValue={idSelected}
                propKey={propKey}
                propValue={propValue}
                addEmpty={false}
                displayEmpty={false}
                emptyLabel={I18n.t(emptyLabel)}
                label={I18n.t(label)}
            />
        );
    }
}

export default withStyles(oplAppStyle)(SimpleSelectRest);
